import logo from './images/logo/logo.png';

import blog1 from './images/blog/blog1.jpg';
import blog2 from './images/blog/blog2.jpg';
import blog3 from './images/blog/blog3.jpg';

import member1 from './images/team/member1.jpg';
import member2 from './images/team/member2.jpg';
import member3 from './images/team/member3.jpg';

import project1 from './images/projects/s1.jpg';
import project2 from './images/projects/s2.PNG';
import project3 from './images/projects/s3.JPG';
import project4 from './images/projects/s4.PNG';
import project5 from './images/projects/s5.PNG';
import project8 from './images/projects/s8.PNG';
import project9 from './images/projects/s9.PNG';
import project10 from './images/projects/s10.PNG';
import project11 from './images/projects/s11.JPG';

import p1a from './images/portfolio/p1/0D5CD188-DCD7-4C04-A17D-8645557BB53A.jpg';
import p1b from './images/portfolio/p1/34F253BB-5BA6-434A-90BA-FBEC12B1E8C4.jpg';

import p2a from './images/portfolio/p2/31858557-d168-453a-9cff-db92178ba34b.jpg';
import p2b from './images/portfolio/p2/3534F66D-EA85-4A28-A1B5-37CD8E0234DD.jpg';
import p2c from './images/portfolio/p2/49AC6E9F-BB03-4DBE-B57C-9E9D7F413622.jpg';

import p3a from './images/portfolio/p3/p3a.jpg';
import p3b from './images/portfolio/p3/p3b.jpg';
import p3c from './images/portfolio/p3/p3c.jpg';

import p4a from './images/portfolio/p4/5A233EC0-ACA1-41BB-8D27-46FCF09C51A5.jpg';
import p4b from './images/portfolio/p4/74622E1C-F28B-44D8-B40C-1A833879743A.jpg';
import p4c from './images/portfolio/p4/B56EE7E6-CE42-4BCA-A30D-2B83D2D61634.jpg';
import p4d from './images/portfolio/p4/EB10415A-36C9-4B9C-9CE2-F42E6AFE3C4C.jpg';

import p5a from './images/portfolio/p5/55D82100-86E2-4D23-BAE4-87A507196193.jpg';
import p5b from './images/portfolio/p5/B43CDD72-E820-4FEA-BEC8-E2C901A5D43C.jpg';

import p6a from './images/portfolio/p6/292E739D-399F-4F22-946B-ECD99AD76163.jpg';
import p6b from './images/portfolio/p6/4E107F23-4B21-46A4-81C3-95EA174FEDFF.jpg';
import p6c from './images/portfolio/p6/9B4CFEFB-82EF-4E37-8049-2FF442EC91B3.jpg';

import p7a from './images/portfolio/p7/0097E296-D944-4EA8-9398-A5D0C017425B.jpg';
import p7b from './images/portfolio/p7/4C047FF1-0850-476E-808B-0CF0ABB51A81.jpg';
import p7c from './images/portfolio/p7/64F8C016-5731-477F-AAF3-8C8CCE0A1910.jpg';
import p7d from './images/portfolio/p7/C68BEFF6-DDF2-463A-8216-3868BFBE9C3A.jpg';
import p7e from './images/portfolio/p7/EEA6D3A7-80A1-46BC-A791-6570A64D3412.jpg';

import p9a from './images/portfolio/p9/EE186D69-D1EE-4359-A284-5C4E8925FEB3.jpg';
import p9b from './images/portfolio/p9/FD9E3590-116E-411E-A7DD-43ED7B81636D.jpg';

import gallery1 from './images/gallery/gallery1.jpg';
import gallery2 from './images/gallery/gallery2.jpg';
import gallery3 from './images/gallery/gallery3.jpg';
import gallery4 from './images/gallery/gallery4.jpg';
import gallery5 from './images/gallery/gallery5.jpg';
import gallery6 from './images/gallery/gallery6.jpg';
import gallery7 from './images/gallery/gallery7.jpg';
import gallery8 from './images/gallery/gallery8.jpg';
import gallery9 from './images/gallery/gallery9.jpg';
import gallery10 from './images/gallery/gallery10.jpg';
import gallery11 from './images/gallery/gallery11.jpg';
import gallery12 from './images/gallery/gallery12.jpg';
import gallery13 from './images/gallery/gallery13.jpg';
import gallery14 from './images/gallery/gallery14.jpg';
import gallery15 from './images/gallery/gallery15.jpg';
import gallery16 from './images/gallery/gallery16.jpg';
import projectFeature from './images/gallery/project-img2.jpg';

import postImage from './images/posts/single-post-img.jpg';
import author from './images/posts/author.jpg';
import commenter1 from './images/posts/commenter1.jpg';
import commenter2 from './images/posts/commenter2.jpg';
import commenter3 from './images/posts/commenter3.jpg';

import tab1 from './images/services/tab1.jpg';
import transformationalDesigns from './images/services/transformational_designs.png';

import insta1 from './images/instagram/1.jpg';
import insta2 from './images/instagram/2.jpg';
import insta3 from './images/instagram/3.jpg';
import insta4 from './images/instagram/4.jpg';
import insta5 from './images/instagram/5.jpg';
import insta6 from './images/instagram/6.jpg';
import insta7 from './images/instagram/7.jpg';
import insta8 from './images/instagram/8.png';

import interior1 from './images/Interiors/IMG_0147.jpg';
import interior2 from './images/Interiors/IMG_0150.jpg';
import interior3 from './images/Interiors/IMG_0152.jpg';
import interior4 from './images/Interiors/IMG_8665.jpg';
import interior5 from './images/Interiors/IMG_8426.jpg';
import interior6 from './images/Interiors/IMG_8423.jpg';
import interior7 from './images/Interiors/IMG_8371.jpg';
import interior8 from './images/Interiors/IMG_8377.jpg';
import interior9 from './images/Interiors/IMG_9128.jpg';
import interior10 from './images/Interiors/IMG_9130.jpg';
import interior11 from './images/Interiors/IMG_7886.jpg';
import interior12 from './images/Interiors/IMG_7887.jpg';
import interior13 from './images/Interiors/IMG_8382.jpg';
import interior14 from './images/Interiors/IMG_8424.jpg';
import interior15 from './images/Interiors/IMG_8425.jpg';
import interior16 from './images/Interiors/IMG_8378.jpg';
import interior17 from './images/Interiors/IMG_9127.jpg';
import interior18 from './images/Interiors/IMG_8685.jpg';
import interior19 from './images/Interiors/IMG_6848.jpg';
import interior20 from './images/Interiors/8FD26767-FC9F-4EBB-96B2-610BE4659BBF.jpg';
import interior21 from './images/Interiors/E2C24E8E-1AC5-4C13-9963-EDC1434885A5.jpg';
import interior22 from './images/Interiors/B6015FC7-7915-4327-987F-E575DEEECF3F.jpg';
import interior23 from './images/Interiors/958EEF23-7329-4912-A81D-13926C094281.jpg';
import interior24 from './images/Interiors/625D379B-B07B-4CEA-8B70-21AC38961466.jpg';
import interior25 from './images/Interiors/8C74F3C4-87FB-420F-841A-F03BF5C04188.jpg';
import interior26 from './images/Interiors/8A36A49E-5DAF-4333-A987-6703B97C8153.jpg';
import interior27 from './images/Interiors/ABEFDEAF-3247-437A-AAB4-5886C4A7AAD4.jpg';
import interior28 from './images/Interiors/04483a0f-36c5-4b77-a56b-d5860afdf751.jpg';
import interior29 from './images/Interiors/1ded95ff-d287-4c0d-bc13-590963906147.jpg';
import interior30 from './images/Interiors/3401cad7-9d6d-4efa-b388-1917aecc6530.jpg';
import interior31 from './images/Interiors/51fe9c58-1038-4511-8ce0-d0540b364bd2.jpg';
import interior32 from './images/Interiors/b486c022-fdf8-4657-8a8c-bc30ece4e101.jpg';

export const images = {
  logo,
  blog: [blog1, blog2, blog3],
  team: [member1, member2, member3],
  projects: [
    project1,
    project2,
    project3,
    project4,
    project5,
    project8,
    project9,
    project10,
    project11,
  ],
  projectGalleries: {
    1: [p1a, p1b],
    2: [p2a, p2b, p2c],
    3: [p3a, p3b, p3c],
    4: [p4a, p4b, p4c, p4d],
    5: [p5a, p5b],
    6: [p6a, p6b, p6c],
    7: [p7a, p7b, p7c, p7d, p7e],
    9: [p9a, p9b],
  },
  gallery: [
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,
    gallery10,
    gallery11,
    gallery12,
    gallery13,
    gallery14,
    gallery15,
    gallery16,
  ],
  projectFeature,
  posts: {
    postImage,
    author,
    commenters: [commenter1, commenter2, commenter3],
  },
  services: {
    tab1,
    transformationalDesigns,
  },
  instagram: [insta1, insta2, insta3, insta4, insta5, insta6, insta7, insta8],
  interiors: [
    interior1,
    interior2,
    interior3,
    interior4,
    interior5,
    interior6,
    interior7,
    interior8,
    interior9,
    interior10,
    interior11,
    interior12,
    interior13,
    interior14,
    interior15,
    interior16,
    interior17,
    interior18,
    interior19,
    interior20,
    interior21,
    interior22,
    interior23,
    interior24,
    interior25,
    interior26,
    interior27,
    interior28,
    interior29,
    interior30,
    interior31,
    interior32,
  ],
};

export default images;
